<style lang="sass">

    @import ../../common/styles/settings
    @import ../../common/styles/mixins

    .page--solution
        .section--collapse
            margin-top: 85px
            +media('<medium')
                margin-top: 0
        &__seo
            text-align: center
            font-weight: 400
            margin: 1.375rem auto 0
            max-width: 54em

</style>

<script>
    import Newsfeed from '../../common/components/Newsfeed.vue'
      export default {
         components: {
             Newsfeed
         }
     }
</script>
